import React, { useState } from "react";
import { Modal } from "react-materialize";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { logOut } from "../redux/action/auth";

function Aside({ openAside, setOpenAside }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const [logout, setLogout] = useState(false);
  const { accountType } = useSelector((state) => state?.account);

  const pathurl = localStorage.getItem("pathurl");
  const pathurl1 = localStorage.getItem("create-path");

  const includeSingleListRoute = pathurl === "/";
  const includeSingleListRoute1 = pathurl1 === "home";
  const isMatchingRoute = (pathname, routes) => {
    return routes.some((route) => {
      const regex = new RegExp(`^${route.replace(/:\w+/g, "[^/]+")}$`);
      return regex.test(pathname);
    });
  };

  const buyerRoutes = [
    "/",
    "/auction-details/:param1",
    "/catalogue-detail/:params3",
    "/request-Inspection/:params2",
    "/confirm-lots-payment/:param1/:param2",
    "/download/inspection-pdf/:param1",
  ];
  const buyerRoute = isMatchingRoute(location?.pathname, buyerRoutes);

  const subscriptionRoutes = [
    "/subscription",
    "/subscriptionDetails/:Standard",
    "/subscription/successful",
  ];
  const subscriptionRoute = isMatchingRoute(
    location?.pathname,
    subscriptionRoutes
  );

  const accountRoutes = [
    "/account",
    "/account/archive",
    "/account/update",
    "/account/add-bank",
    "/account/holder-account",
  ];
  const accountRoute = accountRoutes.includes(location?.pathname);

  const walletRoutes = [
    "/wallet",
    "/wallet/add-money",
    "/wallet/addMoney-details",
    "/successful-add-money",
    "/wallet/add-bank",
    "/wallet/bank-details",
    "/wallet/wallet-account",
    "/wallet/archive",
    "/wallet/update-bank",
  ];
  const walletRoute = walletRoutes.includes(location?.pathname);

  const InspectionRoutes = ["/inspectList", "/inspectList/response/:params1"];
  const InspectionRoute = isMatchingRoute(location?.pathname, InspectionRoutes);

  const InspectionSellerRoutes = ["/inspectList"];
  const InspectionSellerRoute = isMatchingRoute(
    location?.pathname,
    InspectionSellerRoutes
  );

  // const BidHistoryRoutes = ["/bid-history", "/bit/details"];
  // const BidHistoryRoute = BidHistoryRoutes.includes(location.pathname);

  const DashboardRoutes = [
    "/",
    ...(includeSingleListRoute
      ? [
          "/single-auction/:listId",
          "/singleOffer/:param1/:param2",
          "/offerBids/:param1/:param2",
          ...(includeSingleListRoute1
            ? [
                "/createAuction-lots/:params1",
                "/download-bids-history/:param1/:param2",
              ]
            : []),
        ]
      : []),
  ];

  const DashboardRoute = isMatchingRoute(location?.pathname, DashboardRoutes);
  // const CreateRoutes = [
  //   "/create-auction",
  //   ...(!includeSingleListRoute1 ? ["/createAuction-lots/:params1"] : []),
  // ];
  // const CreateRoute = isMatchingRoute(location.pathname, CreateRoutes);

  const AuctionStatusRoutes = [
    "/auction-status",
    ...(!includeSingleListRoute
      ? [
          "/single-auction/:listId",
          "/singleOffer/:param1/:param2",
          "/offerBids/:param1/:param2",
          "/createAuction-lots/:params1",
          "/download-bids-history/:param1/:param2",
        ]
      : []),
  ];
  const AuctionStatusRoute = isMatchingRoute(
    location?.pathname,
    AuctionStatusRoutes
  );

  const pickupRoutes = ["/pickup"];
  const pickupRoute = pickupRoutes.includes(location?.pathname);

  const menuItemsForBuyer = [
    { route: "/", label: "Dashboard", icon: "dashboard", active: buyerRoute },
    {
      route: "/documents/showDetails",
      label: "Documents",
      icon: "note",
      active: location?.pathname === "/documents/showDetails",
    },
    {
      route: "/subscription",
      label: "Subscription",
      icon: "subscriptions",
      active: subscriptionRoute,
    },
    {
      route: "/account",
      label: "Accounts",
      icon: "account_balance",
      active: accountRoute,
    },
    {
      route: "/wallet",
      label: "Wallet",
      icon: "account_balance_wallet",
      active: walletRoute,
    },
    {
      route: "/inspectList",
      label: "Inspection",
      icon: "view_list",
      active: InspectionRoute,
    },
    // {
    //   route: "/bid-history",
    //   label: "Bid Detail",
    //   icon: "history",
    //   active: BidHistoryRoute,
    // },
    // {
    //   route: "/pickup",
    //   label: "Pickups",
    //   icon: "local_shipping",
    //   active: pickupRoute,
    // },
    // {
    //   route: "/helpline",
    //   label: "Helpline",
    //   icon: "headset_mic",
    //   active: location.pathname === "/helpline",
    // },
    {
      route: "/profile",
      label: "Profile",
      icon: "account_circle",
      active: location?.pathname === "/profile",
    },
  ];

  const menuItemsForSeller = [
    {
      route: "/",
      label: "Dashboard",
      icon: "dashboard",
      active: DashboardRoute,
    },
    // {
    //   route: "/create-auction",
    //   label: "Create-Auction",
    //   icon: "add_box",
    //   active: CreateRoute,
    // },
    {
      route: "/auction-status",
      label: "Auction-Status",
      icon: "work_history",
      active: AuctionStatusRoute,
    },
    {
      route: "/wallet",
      label: "Wallet",
      icon: "account_balance_wallet",
      active: walletRoute,
    },
    // {
    //   route: "/inspectList",
    //   label: "Inspection",
    //   icon: "view_list",
    //   active: InspectionSellerRoute,
    // },
    // {
    //   route: "/pickup",
    //   label: "Pickups",
    //   icon: "local_shipping",
    //   active: pickupRoute,
    // },
    // {
    //   route: "/helpline",
    //   label: "Helpline",
    //   icon: "headset_mic",
    //   active: location.pathname === "/helpline",
    // },
    {
      route: "/profile",
      label: "Profile",
      icon: "account_circle",
      active: location?.pathname === "/profile",
    },
  ];

  const menuItems =
    accountType === "industry" ? menuItemsForSeller : menuItemsForBuyer;
  return (
    <aside className={openAside ? "aside-list-open" : "aside-list"}>
      <ul className="aside-items-list">
        {menuItems?.map((item, index) => (
          <li
            key={item?.route}
            className={item.active ? "active-aside-items-list" : ""}
            onClick={() => {
              navigate(item.route);
              setOpenAside(false);
            }}
            data-tooltip-id={`tooltip-${index}`}
          >
            <span className="material-icons-outlined">{item.icon}</span>
            {openAside && <p className="semi-bold">{item.label}</p>}
          </li>
        ))}
      </ul>
      {!openAside &&
        menuItems?.map((item, index) => (
          <ReactTooltip
            key={item?.route}
            id={`tooltip-${index}`}
            place="right"
            content={<p>{item.label}</p>}
          />
        ))}
      <div
        className="flex mb-5 ml-3 align-center full-width  hover"
        href="#modal1"
        onClick={() => setLogout(!logout)}
      >
        <span
          className="material-symbols-outlined icon pointer"
          data-tooltip-id={`${!openAside && "tooltip-logout"}`}
        >
          logout
        </span>
        {openAside && <p className="semi-bold">Logout</p>}
        <Modal
          actions={[]}
          id="modal1"
          open={logout}
          options={{
            onCloseEnd: () => setLogout(false),
          }}
        >
          <b className="normal-size">Confirm Logout </b>
          <p className="semi-bold">Are you sure you want to logout?</p>
          <div className="flex justify-end gap-1">
            <button
              className="green btn-small "
              onClick={() => dispatch(logOut())}
            >
              Yes
            </button>

            <button className="red btn-small" onClick={() => setLogout(false)}>
              No
            </button>
          </div>
        </Modal>
      </div>
      <ReactTooltip
        id={`tooltip-logout`}
        place="right"
        content={<p>Logout</p>}
      />
    </aside>
  );
}

export default Aside;
